import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';
import { AvailableDateRange, Period } from '@src/api/types/communityDashboard';
import { Pagination } from '@src/api/types/pagination';
import { IndexRequest } from '@src/api/types/shared/request';

export type ChannelActivityListItem = {
  channel_id: number;
  channel_name: string;
  visibility: number | string;
  channel_created_at: string | null;
  members_count: number;
  posts: number;
  reactions: number;
  total_actions: number;
  latest_posted_at: string | null;
};

type ChannelActivityIndexResponse = {
  period: Period;
  available_date_range: AvailableDateRange;
  data: ChannelActivityListItem[];
  pagination: Pagination;
  validation_messages?: string[];
};

export const communityChannelActivityApiClient = {
  index: async (
    requestParameters: IndexRequest = {},
  ): Promise<ApiResult<ChannelActivityIndexResponse, never>> => {
    return await axiosClient.get('/tenant/dashboard/channel-stats', {
      params: requestParameters,
    });
  },

  csvExport: async (requestParameters: IndexRequest = {}): Promise<ApiResult<Blob, never>> => {
    return await axiosClient.get('/tenant/dashboard/channel-stats/csv-export', {
      params: requestParameters,
      responseType: 'blob',
    });
  },
};
